module.exports = __webpack_public_path__ + "images/sofort.f8ece39efe252d49bbba69622951b716.svg";